import { useCurrentUserDetails } from './current-user.hook';

export interface UseIsExternalUserResult {
    /** True once the user record has loaded and the user is external. */
    isExternalUser: boolean;
    /** True once the user record has loaded and the user is internal. */
    isInternalUser: boolean;
    /** Still fetching `useCurrentUserDetails()` — treat both flags as not-yet-decided. */
    isLoading: boolean;
}

/**
 * Convenience wrapper around `useCurrentUserDetails()` for places where
 * only the external/internal classification of the *current* user is
 * needed — typically alongside `useHasPermissions()` when a feature
 * differs between internal Reneo employees and external partners.
 *
 * Use the full `useCurrentUserDetails()` hook when you also need the
 * user object, admin flag, or query error.
 */
export function useIsExternalUser(): UseIsExternalUserResult {
    const { isExternalUser, isInternalUser, isLoading } = useCurrentUserDetails();
    return { isExternalUser, isInternalUser, isLoading };
}
